import { type ApiRequest } from '@/api/tenantClient';

export function useGlobalApi() {
  const createGlobalApiRequest = (): ApiRequest => {
    return {
      method: 'POST',
      endpoint: {
        path: ''
      },
    };
  };

  const createGlobalApiAclRequestByAuthToken = (accessToken: string) => (): ApiRequest => {
    return {
      method: 'POST',
      endpoint: {
        path: ''
      },
      headers: {
        'access-token': accessToken,
      }
    };
  };

  return {
    createGlobalApiRequest,
    createGlobalApiAclRequestByAuthToken,
  }
}
